mtl.alloy.factory.slideshow = (function($) {
    'use strict';

    var SLIDE_SEPARATION_PERCENT = 120;

    var TWEEN_DURATION = 900;

    var ACTIVE_THRESHOLD = 0.8;

    var AUTO_ADVANCE_DELAY = 8000;


    /**
     * Return the slideshow factory.
     */
    return function(element, options) {

        var $element = $(element).first();
        element = $element[0];

        var $slides = $element.find('[data-ref="slide-list"]').children();
        if ($slides.length < 2) {
            return;
        }

        var $pips = $element.find('[data-ref="pip-list"]').children();

        var isAnimating = false;
        var currentOffset = 0;

        var tweener = util.arrayTweener([currentOffset], TWEEN_DURATION, $.easie(0.4, 0, 0.4, 1));

        var autoAdvanceTimer = -1;


        // Keep track of the state of each slide to avoid costly DOM calls
        var slideStates = $slides.map(function(i) {
            return {
                isActive:  !i,
                display:   i ? '' : 'none',
                opacity:   i ? 0 : 1,
            };
        });


        /**
         * Convert an offset to an index.
         */
        function offsetToIndex(_offset, _toInteger) {

            var _length = $slides.length | 0;

            var _index = _offset % _length;

            if (_toInteger === true) {
                _index = Math.round(_index) | 0;
            }

            if (_index < 0) {
                _index += _length;
            }

            return _index;

        }


        /**
         * Create a timer to auto-advance to the next slide.
         */
        function autoAdvance() {

            if (autoAdvanceTimer > -1) {
                clearTimeout(autoAdvanceTimer);
                autoAdvanceTimer = -1;
            }

            autoAdvanceTimer = setTimeout(function() {
                autoAdvanceTimer = -1;
                goToNext();
            }, AUTO_ADVANCE_DELAY);

        }


        /**
         * Update the slide transforms.
         */
        function updateTransforms() {

            var _length = $slides.length | 0;
            var _offset = tweener.getTweenedValues()[0];
            var _index = offsetToIndex(_offset);

            var _targetIndex = offsetToIndex(currentOffset, true) | 0;

            $slides.each(function(_slideIndex, _slideElement) {

                var _delta = _slideIndex - _index;
                if (_delta < -1) {
                    _delta += _length;
                }

                var _opacity = Math.max(0, Math.min(1 - Math.abs(_delta), 1));
                var _display = (_opacity > 0.01) ? '' : 'none';

                var _css = {
                    transform: 'translate3d(' + (_delta * SLIDE_SEPARATION_PERCENT) + '%, 0, 0)',
                };

                var _state = slideStates[_slideIndex];
                if (_display !== _state.display) {
                    _css.display = _state.display = _display;
                }
                if (_opacity !== _state.opacity) {
                    _css.opacity = _state.opacity = _opacity;
                }

                var $slide = $(_slideElement).css(_css);

                var _isActive = (_opacity > ACTIVE_THRESHOLD && _slideIndex === _targetIndex);
                if (_isActive !== _state.isActive) {
                    _state.isActive = _isActive;
                    $slide.toggleClass('is-active', _isActive);
                }

            });

        }


        /**
         * Activate the given index.
         */
        function activateIndex(_index) {

            _index = _index | 0;

            $pips.each(function(i, _pip) {

                $(_pip).toggleClass('is-active', (_index === i));

            });

        }


        /**
         * Start animation loop.
         */
        function startAnimation() {

            if (isAnimating) {
                return;
            }

            requestAnimationFrame(animationLoop);

            isAnimating = true;

        }


        /**
         * Animation loop.
         */
        function animationLoop() {

            tweener.tick();
            updateTransforms();

            if (tweener.isActive()) {
                requestAnimationFrame(animationLoop);
            }

            else {
                endAnimation();
            }

        }


        /**
         * End animation loop.
         */
        function endAnimation() {

            if (!isAnimating) {
                return;
            }

            goToOffset(offsetToIndex(currentOffset), true);

            isAnimating = false;

        }


        /**
         * Go to the given offset.
         */
        function goToOffset(_offset, _instant) {

            _offset = _offset | 0;

            if (_offset === currentOffset && _instant !== true) {
                return;
            }

            if (_instant !== true) {
                tweener = tweener.tweenTo([_offset]);
                if (!isAnimating) {
                    startAnimation();
                }
            }

            else {
                tweener.resetTo([_offset]);
                updateTransforms();
                isAnimating = false;
            }

            activateIndex(offsetToIndex(_offset));
            autoAdvance();

            currentOffset = _offset;

        }


        /**
         * Go to the given index.
         */
        function goToIndex(_index, _instant) {

            _index = _index | 0;

            var _delta = _index - offsetToIndex(currentOffset);

            goToOffset(currentOffset + _delta, _instant);

        }


        /**
         * Go to the next slide.
         */
        function goToNext(_instant) {

            goToOffset(currentOffset + 1, _instant);

        }


        /**
         * Go to the previous slide.
         */
        function goToPrev(_instant) {

            goToOffset(currentOffset - 1, _instant);

        }


        /**
         * On clicking one of the navigation pips.
         */
        function onClickPip(event) {

            goToIndex(
                $pips.index(event.currentTarget)
            );

        }


        // Bind event listeners
        $element
            .on('click', '[data-ref="next-btn"]', goToNext)
            .on('click', '[data-ref="prev-btn"]', goToPrev)
            .on('click', '[data-ref="pip-list"] button', onClickPip)
        ;

        // Start at
        goToIndex(0, true);

    };

}(jQuery));
